import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import HomePage from '../pages/home/home.page';
import AboutPage from '../pages/about/about.page';
import ContactPage from '../pages/contact/contact.page';
import CoursesPage from '../pages/courses/courses.page';
import CourseDetailsPage from '../pages/courseDetails/courseDetails.page';
import CourseDraftDetailsPage from '../pages/courseDetails/courseDraftDetailspage.jsx';
import PublicationsPage from '../pages/publications/publications.page';
import MedicalCollegesPage from '../pages/medicalColleges/medicalColleges.page';
import CollegeDetailsPage from '../pages/collegeDetails/collegeDetails.page';
import CollegeCategoryPage from '../pages/collegeCategory/collegeCategory.page';
import BranchesPage from '../pages/branches/branches.page';
import PublicationCategoryPage from '../pages/publicationCategory/publicationCategory.page';
import PublicationDetailsPage from '../pages/publicationDetails/publicationDetails.page';
import PhotoGalleryPage from '../pages/photoGallery/photoGallery.page';
import PhotoAlbumPage from '../pages/photoGallery/PhotoAlbum.page';
import VideoGalleryPage from '../pages/videoGallery/videoGallery.page';
import VideoAlbumPage from '../pages/videoGallery/videoAlbum.page';
import Blogs from '../pages/Blogs/blogs.page';
import BlogDetails from '../pages/Blogs/blogDetails.page';
import DraftDetails from '../pages/Blogs/blogDraftDetails';
import ExamsPage from '../pages/exams/exams.page';
import ExamDetailsPage from '../pages/examDetails/examDetails.page';
import ExamDraftDetails from '../pages/examDetails/examDraftDetails';
import Error404 from '../components/Error/Error404'
import TermsAndConditionsPage from '../pages/Terms/TermsAndConditions.page';
import PrivacyPolicyPage from '../pages/privacyPolicy/PrivacyPolicy.page';

const PublicRoutes = props => {
    return (
        <Switch>
            <Route exact path='/' component={HomePage} />
            <Route exact path='/about' component={AboutPage} />
            <Route exact path='/contact' component={ContactPage} />
            <Route exact path='/courses' component={CoursesPage} />
            <Route exact path='/courses/:title/:courseId' component={CourseDetailsPage} />
            <Route exact path='/admin-only-view-course-draft/:title/:draftId' component={CourseDraftDetailsPage} />
            <Route exact path='/exams' component={ExamsPage} />
            <Route exact path='/exams/:title/:examId' component={ExamDetailsPage} />
            <Route exact path='/admin-only-view-exam-draft/:title/:draftId' component={ExamDraftDetails} />
            <Route exact path='/publications' component={PublicationsPage} />
            <Route exact path='/publications/:category' component={PublicationCategoryPage} />
            <Route exact path='/publication/:title/:id' component={PublicationDetailsPage} />
            <Route exact path='/medical-colleges' component={MedicalCollegesPage} />
            <Route exact path='/medical-colleges/:categoryName/:categoryId' component={CollegeCategoryPage} />
            <Route exact path='/medical-college/:collegeName/:categoryId/:collegeId' component={CollegeDetailsPage} />
            <Route exact path='/branches' component={BranchesPage} />
            <Route exact path='/gallery/photos' component={PhotoGalleryPage} />
            <Route exact path='/gallery/photos/:albumId' component={PhotoAlbumPage} />
            <Route exact path='/gallery/videos' component={VideoGalleryPage} />
            <Route exact path='/gallery/videos/:albumId' component={VideoAlbumPage} />
            <Route exact path='/blogs' component={Blogs} />
            <Route exact path='/blog/:name/:blogId' component={BlogDetails} />
            <Route exact path='/admin-only-view-blog-draft/:name/:draftId' component={DraftDetails} />
            <Route exact path='/terms-and-conditions' component={TermsAndConditionsPage} />
            <Route exact path='/privacy-policy' component={PrivacyPolicyPage} />
            <Route exact path='*' component={Error404} />
        </Switch>
    )
};

export default PublicRoutes;